module.exports = __webpack_public_path__ + "img/interior_14.5eadefaa.jpg";